enum MAINTENANCE_TYPE {
  ALL = 'all',
  DEMANDS = 'demands',
  GED = 'ged',
}

export default MAINTENANCE_TYPE
